import { DrawRecordTypes, PinDirection, } from "../schematicModels";
import { BaseSvgConverter } from "./BaseSvgConverter";
import { SymbolHelpers } from "./SymbolHelpers";
// KiCAD Schematic spec: https://en.wikibooks.org/wiki/Kicad/file_formats#Schematic_Files_Format
export class SymbolToSvgConverter extends BaseSvgConverter {
    constructor(drawInstructions) {
        super();
        /**
         * Converts KiCad file format to SVG by executing all KiCad draw
         * instructions and flipping the vertical axis of all paths.
         *
         *            (+)                                (-)
         *             ^                                  ^
         *             |                                  |
         *    (-) <---------> (+)                (-) <---------> (+)
         *             |                                  |
         *             v                                  v
         *            (-)                                (+)
         *           KiCad   -- flip vertical axis -->   SVG
         *
         * The origin of an SVG may be arbitrarily placed, and does not
         * necessarily align with the center of the SVG bounding box.
         * Elsewhere in the codebase we assume a centered SVG, so it can
         * be useful to know the translation FROM the center of the SVG
         * TO the origin.
         *
         *    end.y       +---------------------+
         *      |         |    X origin         | SVG boundary
         *      |         |                     |
         *      |         |          X center   |
         *      |         |                     |
         *      |         |                     |
         *   start.y      +---------------------+
         *
         *              start.x -------------- end.x
         */
        this.executeDrawInstructions(drawInstructions);
        this.configureSvgContainer();
    }
    executeDrawInstructions(drawInstructions) {
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        drawInstructions.forEach((drawInstruction) => {
            switch (drawInstruction.type) {
                case DrawRecordTypes.rectangle: {
                    const instruction = drawInstruction;
                    this.createRectangle(instruction.startX, SymbolHelpers.invertAxis(instruction.startY), instruction.endX, SymbolHelpers.invertAxis(instruction.endY), instruction.thickness);
                    break;
                }
                case DrawRecordTypes.pin: {
                    const instruction = drawInstruction;
                    this.createPin(instruction.pinName, instruction.pinNumber, instruction.posX, SymbolHelpers.invertAxis(instruction.posY), instruction.pinLength, instruction.pinDirection);
                    break;
                }
                case DrawRecordTypes.polyline: {
                    const instruction = drawInstruction;
                    this.createPolyline(instruction.thickness, instruction.points.map((point) => {
                        return {
                            x: point.x,
                            y: SymbolHelpers.invertAxis(point.y),
                        };
                    }), instruction.style);
                    break;
                }
                case DrawRecordTypes.circle: {
                    const instruction = drawInstruction;
                    this.createCircle(instruction.posX, SymbolHelpers.invertAxis(instruction.posY), instruction.radius, instruction.thickness);
                    break;
                }
                case DrawRecordTypes.arcWithOrigin: {
                    const instruction = drawInstruction;
                    this.createArc(instruction.posX, SymbolHelpers.invertAxis(instruction.posY), instruction.radius, instruction.startAngle, instruction.endAngle, instruction.startX, SymbolHelpers.invertAxis(instruction.startY), instruction.endX, SymbolHelpers.invertAxis(instruction.endY), instruction.thickness);
                    break;
                }
                case DrawRecordTypes.polygon: {
                    const instruction = drawInstruction;
                    const path = this.createPolygon(instruction.points);
                    this.svgContainer.appendChild(path);
                    break;
                }
                case DrawRecordTypes.curve: {
                    const instruction = drawInstruction;
                    this.TEMP_drawArc(instruction.startPoint.x, instruction.startPoint.y, instruction.midPoint.x, instruction.midPoint.y, instruction.endPoint.x, instruction.endPoint.y, instruction.thickness);
                    break;
                }
            }
        });
    }
    createPin(_pinName, _pinNumber, posX, posY, pinLength, pinDirection) {
        let path;
        switch (pinDirection) {
            case PinDirection.left:
                path = this.drawLine(posX, posY, posX - pinLength, posY);
                break;
            case PinDirection.right:
                path = this.drawLine(posX, posY, posX + pinLength, posY);
                break;
            case PinDirection.up:
                // Flips vertical direction:
                path = this.drawLine(posX, posY, posX, posY - pinLength);
                break;
            case PinDirection.down:
                // Flips vertical direction:
                path = this.drawLine(posX, posY, posX, posY + pinLength);
                break;
        }
        if (path) {
            this.svgContainer.appendChild(path);
        }
    }
}
//# sourceMappingURL=SymbolToSvgConverter.js.map